import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { useDomainConfig } from 'hooks/useDomainConfig';
import useTranslation from 'next-translate/useTranslation';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

export const QuickOrderButton: FC = () => {
    const { t } = useTranslation();
    const { url: domainUrl } = useDomainConfig();
    const [quickOrderUrl] = getInternationalizedStaticUrls(['/b2b-quick-order'], domainUrl);

    return (
        <ExtendedNextLink
            href={quickOrderUrl}
            type="static"
            className="group inline-flex hidden min-h-[50px] w-auto cursor-pointer items-center justify-center rounded-md border-0 bg-green py-[13px] px-9 text-center text-h6 font-medium !leading-5 text-white no-underline outline-0 transition-colors duration-200 ease-defaultTransition hover:bg-[#004d3a] hover:text-white hover:no-underline active:scale-95 lg:text-h5 vl:block [&>svg:first-child]:mr-3 [&>svg:last-child:not(:first-child)]:ml-3 [&>svg]:hover:text-white"
        >
            {t('Quick order')}
        </ExtendedNextLink>
    );
};
